// Per-device identity. No accounts, no login — a stable random id lives in
// localStorage so the leaderboard can keep one row per device (your personal
// best) and highlight it as yours. The display name is editable and reused
// across games. Switching browsers/devices = a fresh identity (a deliberate
// trade for zero-friction play).

import { NAME_MAX } from "../shared/protocol";

const ID_KEY = "su_pid";
const NAME_KEY = "pa_name"; // shared with the older name storage

export function playerId(): string {
  let id = "";
  try { id = localStorage.getItem(ID_KEY) || ""; } catch { /* private mode */ }
  if (!id) {
    id = (crypto?.randomUUID?.() ||
      `p_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`);
    try { localStorage.setItem(ID_KEY, id); } catch { /* */ }
  }
  return id;
}

export function playerName(): string {
  try { return localStorage.getItem(NAME_KEY) || ""; } catch { return ""; }
}

export function setPlayerName(n: string): void {
  try { localStorage.setItem(NAME_KEY, (n || "").trim().slice(0, NAME_MAX)); } catch { /* */ }
}
